import { Subject, tap } from 'rxjs';

export const errorSubject = new Subject<Partial<Response>>();
export const errorObservable = errorSubject.asObservable();

export const redirectToErrorPage = (error: Response) => {
    switch (error?.status) {
        case 404:
            window.location.href = '/not-found';
            break;
        case 403:
            window.location.href = '/forbidden';
            break;
        default:
            window.location.href = '/error/something-went-wrong';
            break;
    }
};
